import React from "react";
import { ModuleSelectionPage } from "./Modules/ModuleSelectionPage";
import { ModuleRoute } from "./Modules/ModuleRoute";
import { SharedViewRoute } from "./DesignTab/SharedViews/SharedViewRoute";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import DesignTab from "./DesignTab/DesignTab";
import { useEffect } from "react";
import { selectProjectNo, setProjectNoInRedux } from "./DesignTab/designSlice";
import SettingsPage from "./SettingPage/SettingsPage";
import { RoomTab } from "./RoomTab/RoomTab";
import { useHydrateProjectTabFromUrl } from "./hooks/useHydradeProjectTabFromUrl";
import { useGetMultiplacerProjectsSingleProjectQuery } from "../openapi";
import { ProjectMembers } from "./ProjectMembers/ProjectMembers";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { resetReduxForProjectChange } from "./app/store";
import { DrofusForekomsterPage } from "./DrofusForekomster/DrofusForekomsterPage";
import { DrofusEndringerPage } from "./DrofusEndringer/DrofusEndringerPage";
import { ProjectViewer } from "./ProjectViewer/ProjectViewer";
import { EarthingApiRequestsPage } from "./ProjectViewer/ApiRequests";
import { isProjectViewerOnlyProject } from "./projectViewerOnlyProject";

export const ProjectPage: React.FC = () => {
  const projectNo = useLocation().pathname.split("/")[1];
  const projectNoNumber = Number(projectNo);
  const isViewerOnlyProject = isProjectViewerOnlyProject(projectNo);
  const defaultProjectRoute = isViewerOnlyProject ? "viewer" : "modules";

  const projectNoIs8Digits = /^\d{8}$/.test(projectNo);
  useHydrateProjectTabFromUrl();
  const dispatch = useAppDispatch();
  const reduxProjectNo = useAppSelector(selectProjectNo);

  useEffect(() => {
    if (!projectNoIs8Digits) return;

    if (reduxProjectNo > 0 && reduxProjectNo !== projectNoNumber) {
      dispatch(resetReduxForProjectChange(projectNoNumber));
      return;
    }

    if (reduxProjectNo !== projectNoNumber) {
      dispatch(setProjectNoInRedux(projectNoNumber));
    }
  }, [dispatch, projectNoIs8Digits, projectNoNumber, reduxProjectNo]);

  const { data: project } = useGetMultiplacerProjectsSingleProjectQuery(
    {
      projectNo: projectNoNumber,
    },
    {
      skip: !projectNoIs8Digits,
    }
  );

  if (projectNoIs8Digits && reduxProjectNo !== projectNoNumber) return <div>Laster prosjekt…</div>;

  return (
    <>
      {!projectNoIs8Digits && <div>Ugyldig prosjektnummer i URL</div>}
      <Routes>
        {project != null && (
          <>
            <Route path="/modules" element={<ModuleSelectionPage />} />
            <Route path={"/"} element={<Navigate to={defaultProjectRoute} replace />} />
            <Route
              path={"/design"}
              element={
                isViewerOnlyProject ? (
                  <Navigate to="../viewer" replace />
                ) : (
                  <SharedViewRoute projectNo={projectNoNumber}>
                    <DesignTab />
                  </SharedViewRoute>
                )
              }
            />
            <Route path={"/viewer"} element={<ProjectViewer />} />
            <Route path={"/viewer/apirequests"} element={<EarthingApiRequestsPage />} />
            <Route
              path={"/room"}
              element={
                <ModuleRoute projectNo={projectNoNumber} page="room">
                  <RoomTab />
                </ModuleRoute>
              }
            />
            <Route
              path={"/forekomster"}
              element={
                <ModuleRoute projectNo={projectNoNumber} page="forekomster">
                  <DrofusForekomsterPage />
                </ModuleRoute>
              }
            />
            <Route
              path={"/endringer"}
              element={
                <ModuleRoute projectNo={projectNoNumber} page="endringer">
                  <DrofusEndringerPage />
                </ModuleRoute>
              }
            />
            <Route path={"/settings"} element={<SettingsPage />} />
            <Route path={"/members"} element={<ProjectMembers />} />
          </>
        )}
      </Routes>
    </>
  );
};
